import { en_text } from "./en";
import { es_text } from "./localizations/es";
import { pt_text } from "./localizations/pt";
import { ja_text } from "./localizations/ja";
import { fr_text } from "./localizations/fr";

export const LANGUAGE_CODES = ["en", "es", "pt", "ja", "fr"];

export const localize = (text_identifier: string, language: string) => {
  let text_data;
  switch (language) {
    case "en":
      text_data = en_text;
      break;
    case "es":
      text_data = es_text;
      break;
    case "pt":
      text_data = pt_text || en_text;
      break;
    case "ja":
      text_data = ja_text || en_text;
      break;
    case "fr":
      text_data = fr_text || en_text;
      break;
    default:
      text_data = en_text;
  }
  return text_data?.[text_identifier] || text_identifier;
};
